<app-ui-main-menu>
  <mat-card class="indications-page">
    <mat-card-header>
      <mat-card-title>Consulta de Indicações</mat-card-title>
    </mat-card-header>

    <div class="export-overlay" *ngIf="exporting">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="60"
      ></mat-progress-spinner>
      <span class="export-msg">Gerando CSV, aguarde...</span>
    </div>

    <mat-card-content class="page-content">
      <form [formGroup]="filters" class="row" (ngSubmit)="onSearch()">
        <div class="doctor" class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Médicos</mat-label>

            <mat-select multiple formControlName="doctorId">
              <mat-option
                *ngFor="let doctor of doctorOptions"
                [value]="doctor.id"
              >
                {{ doctor.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field
          appearance="outline"
          class="col-xl-3 col-lg-3 col-md-3 col-sm-12"
        >
          <mat-label>Data da consulta</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              placeholder="Data inicial"
              formControlName="dateFrom"
            />
            <input
              matEndDate
              placeholder="Data final"
              formControlName="dateTo"
            />
          </mat-date-range-input>

          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="col-xl-3 col-lg-3 col-md-3 col-sm-12"
        >
          <mat-label>Laudo</mat-label>
          <mat-select formControlName="hasDocument">
            <mat-option [value]="null" default>Todos</mat-option>
            <mat-option [value]="true">Com Laudo</mat-option>
            <mat-option [value]="false">Sem Laudo</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="col-xl-3 col-lg-3 col-md-3 col-sm-12"
        >
          <mat-label>Status do agendamento</mat-label>
          <mat-select multiple formControlName="status">
            <mat-option value="Aguardando agendamento"
              >Aguardando agendamento</mat-option
            >
            <mat-option value="Aguardando novo agendamento"
              >Aguardando novo agendamento</mat-option
            >
            <mat-option value="Aguardando pagamento"
              >Aguardando pagamento</mat-option
            >
            <mat-option value="Agendado">Agendado</mat-option>
            <mat-option value="Cancelado"
              >Cancelado</mat-option
            >
            <mat-option value="Faltou à consulta">Faltou à consulta</mat-option>
            <mat-option value="Reagendado">Reagendado</mat-option>
            <mat-option value="Atendido">Atendido</mat-option>
            <mat-option value="Arquivado">Arquivado</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="searchBtn">
          <button mat-flat-button color="primary" type="submit">
            Pesquisar
          </button>

          <button
            class="col-2"
            mat-flat-button
            aria-label="Limpar Filtros"
            type="button"
            (click)="clearFilter()"
          >
            <span>Limpar Filtros</span>
          </button>
        </div>
      </form>

      <app-loading *ngIf="loading"></app-loading>

      <ng-container *ngIf="!loading">
        <div *ngIf="dataSource.data.length === 0" class="empty">
          <h3>Nenhum conteúdo disponível</h3>
        </div>

        <div *ngIf="dataSource.data.length > 0" class="table-shell">
          <div class="table-scroll" tabindex="0">
            <table mat-table [dataSource]="dataSource" class="wide-table">
              <ng-container matColumnDef="indicationId">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Identificador da indicação"
                  >
                    Indicação
                  </span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.id }}</td>
              </ng-container>

              <ng-container matColumnDef="accountName">
                <th mat-header-cell *matHeaderCellDef>Escritório</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.patient.account.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>status</th>
                <td mat-cell *matCellDef="let r">{{ r.status }}</td>
              </ng-container>

              <ng-container matColumnDef="documentUrl">
                <th mat-header-cell *matHeaderCellDef>Laudo</th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="row.hasDocument; else noDoc">
                    <button
                      mat-icon-button
                      type="button"
                      (click)="openLaudosModal(row)"
                    >
                      <mat-icon color="primary">check</mat-icon>
                    </button>
                  </ng-container>
                  <ng-template #noDoc>-</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="scheduleDate">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Data do último agendamento da indicação"
                    >Agendamento</span
                  >
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.schedules?.[0]?.date ? (row.schedules[0].date | date:'DD/MM/YYYY') : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="doctorName">
                <th mat-header-cell *matHeaderCellDef>
                  <span
                    class="col-title"
                    matTooltip="Nome do médico do agendamento"
                    >Médico</span
                  >
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.schedules?.[0]?.doctor?.name || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="invoiceId">
                <th mat-header-cell *matHeaderCellDef>Nota Fiscal</th>

                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="row.invoice?.nfeId; else dash">
                    <a
                      [href]="generateInvoiceLink(row.invoice?.nfeId!)"
                      target="_blank"
                      rel="noopener"
                      style="text-decoration: none"
                    >
                      {{ generateInvoiceId(row.invoice?.nfeId) }}
                    </a>
                  </ng-container>
                  <ng-template #dash>-</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="transactionAmount">
                <th mat-header-cell *matHeaderCellDef>Valor Consulta</th>
                <td mat-cell *matCellDef="let row">
                  {{
                    row.transactions[0]?.amount
                      ? (row.transactions[0]?.amount | currency)
                      : "-"
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="previdasAmount">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Serviço de Conveniência & Tecnologia (SCT)">SCT Previdas</span>
                </th>
                <td mat-cell *matCellDef="let row">
                  {{
                    row.transactions[0]?.previdasTransferAmount != null
                      ? (row.transactions[0]?.previdasTransferAmount | currency)
                      : "-"
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="doctorAmount">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Honorário Médico">Honorário Médico</span>
                </th>
                <td mat-cell *matCellDef="let row">
                  {{
                    row.transactions[0]?.doctorTransferAmount != null
                      ? (row.transactions[0]?.doctorTransferAmount | currency)
                      : "-"
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="paymentMethod">
                <th mat-header-cell *matHeaderCellDef>Forma Pgto</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.transactions[0]?.paymentMethod || "-" }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <mat-paginator
            [length]="total"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100, 500]"
            (page)="onSearch($event)"
          >
          </mat-paginator>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
